import React, { useState } from 'react'
// import { useTranslation } from 'react-i18next'
import { Button, Checkbox, Select, TextInput } from 'components/Form'
import { BiSearchAlt } from 'react-icons/bi'
import { AiFillCaretDown, AiFillCaretUp, AiOutlinePlus } from 'react-icons/ai'
import { Link, useNavigate } from 'react-router-dom'
import { asnTypeOptions, filterOptions, lengthOption, siteOptions } from 'utils/options'
import { HiOutlineDownload, HiOutlineEye, HiOutlineEyeOff, HiOutlinePencilAlt, HiOutlineUpload } from 'react-icons/hi'
import Modal from './Modal'
import { convertToCSV, getPagination } from 'components/helper'
import { useDispatch, useSelector } from 'react-redux'
import { setTableColumn } from 'store/table/tableSlice'

const interpolate = require('color-interpolate')
let colormap = interpolate([
    '#ff0000',
    '#fb6436',
    '#ef8d57',
    '#deab6f',
    '#c8c07d',
    '#aecf80',
    '#91d87a',
    '#71db68',
    '#4bd949',
    '#00d100',
])

const defoltclassName = 'py-2 px-2 md:px-4 2xl:px-7'

const Table = ({
    columns,
    loading,
    className,
    datas,
    add_new,
    link,
    link_name,
    file_name,
    search_show = true,
    page_size_show = true,
    filter = true,
    checkboxFilter = false,
    siteFilter = false,
    orderTypeFilter = false,
    statusFilter = false,
    carrierFilter = false,
    customerFilter = false,
    asnTypeFilter = false,
    select = false,
    upload = false,
    download = false,
    buttons = [],
    name = 'datas',
    onChange,
    onClick,
    onUpload,
    pagingData,
    ids,
    setIds,
    grid = 'sm:flex-row sm:justify-between',
    subGrid = 'sm:flex-row sm:justify-between',
    children,
    localStorageKey = '',
    csvDownloadApi,
    view,
    setRecord,
    viewId,
    orderTypeData = [],
}) => {
    // const { t } = useTranslation()

    const {
        pageSize,
        pageIndex,
        total,
        sort,
        query,
        selectedTab,
        checkBox,
        components,
        companyType,
        customer,
        warehouse,
        orderType,
    } = pagingData
    const { customersData, warehouseData } = useSelector(state => state.listData)
    const { allTableColumnData } = useSelector(state => state.table)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const [filterColumn, setFilterColumn] = useState(
        allTableColumnData?.[localStorageKey] ? [...allTableColumnData[localStorageKey]] : [...columns]
    )
    const [visibleColumn, setVisibleColumn] = useState(
        allTableColumnData[localStorageKey] ? [...allTableColumnData[localStorageKey]] : [...columns]
    )

    var totalPage = Math.ceil(total / pageSize)
    var pages = getPagination(pageIndex, totalPage)
    var loadingPages = ['Previous', '...', 'Next']
    const from = pageSize * (pageIndex - 1) + 1
    const to = total > pageSize * pageIndex ? pageSize * pageIndex : total

    // for (let i = 1; i <= totalPage; i++) {
    //     if (i === 1) {
    //         pages.push('Previous')
    //         pages.push(i)
    //     } else if (i === totalPage) {
    //         pages.push(i)
    //         pages.push('Next')
    //     } else {
    //         pages.push(i)
    //     }
    // }

    const ColumnTd = ({ row, column }) => {
        return (
            <td
                style={{ backgroundColor: column?.bg ? colormap(row[column?.bg] * 100) : '' }}
                className={`border-b border-stroke dark:border-strokedark items-center text-sm text-black dark:text-white ${defoltclassName} ${column.className}`}
            >
                {column.renderCell ? column.renderCell(row) : row[column.field]}
            </td>
        )
    }
    const gridClass = `flex flex-col items-center gap-3 ${grid}`
    const subGridClass = `flex flex-col items-center gap-3 ${subGrid}`

    const onDownload = () => {
        csvDownloadApi({ ...pagingData, pageSize: total })
            .then(response => {
                const csvData = convertToCSV(response.data?.results || response.data?.data)
                const blob = new Blob([csvData], { type: 'text/csv' })
                const url = URL.createObjectURL(blob)
                const link = document.createElement('a')
                link.href = url
                link.download = `${file_name || 'download'}.csv`
                link.click()
                URL.revokeObjectURL(url)
            })
            .catch(error => {
                console.error('Error fetching CSV data:', error)
            })

        // const csvData = convertToCSV(datas)
        // const blob = new Blob([csvData], { type: 'text/csv' })
        // const url = URL.createObjectURL(blob)

        // const link = document.createElement('a')
        // link.href = url
        // link.download = `${file_name || 'download'}.csv`
        // link.click()

        // URL.revokeObjectURL(url)
    }

    const onPaginationChange = page => {
        const newTableData = { ...pagingData }
        newTableData.pageIndex = page
        onChange(newTableData)
    }

    const onSelectChange = val => {
        const newTableData = { ...pagingData }
        newTableData.pageSize = val
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onSort = sort => {
        const newTableData = { ...pagingData }
        newTableData.sort = sort
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onSearch = val => {
        const newTableData = { ...pagingData }
        newTableData.query = val
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onTabChange = value => {
        const newTableData = { ...pagingData }
        newTableData.selectedTab = value
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onCheckboxChange = value => {
        const newTableData = { ...pagingData }
        newTableData.checkBox = value
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onComponentFilterChange = value => {
        const newTableData = { ...pagingData }
        newTableData.components = value
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onCompanyTypeChange = value => {
        const newTableData = { ...pagingData }
        newTableData.companyType = value
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    const onOrderTypeChange = value => {
        const newTableData = { ...pagingData }
        newTableData.orderType = value
        newTableData.pageIndex = 1
        onChange(newTableData)
    }

    return (
        <>
            <div className="bg-white mb-5 border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                <div className={`px-3 md:px-4 xl:px-6 ${gridClass}`}>
                    <div className={subGridClass}></div>
                </div>
                <div className={`p-3 md:p-4 xl:p-6 ${gridClass}`}>
                    {search_show && (
                        <TextInput
                            id="search"
                            name="search"
                            value={query ?? ''}
                            onChange={e => onSearch?.(e.target.value)}
                            placeholder={'Search'}
                            icon={<BiSearchAlt />}
                            className="w-full sm:w-auto"
                        />
                    )}
                    {children}
                    {checkboxFilter && (
                        <div className="flex gap-2">
                            <Checkbox
                                id={'register'}
                                name={'register'}
                                checked={checkBox?.includes('register')}
                                onChange={e => {
                                    const { name } = e.target
                                    let arr = [...checkBox]
                                    if (arr.includes(name)) {
                                        if (arr.length > 1) {
                                            arr = arr.filter(item => item !== name)
                                        }
                                    } else {
                                        arr.push(name)
                                    }
                                    onCheckboxChange(arr)
                                }}
                                label={'Register'}
                            />
                            <Checkbox
                                id={'not_register'}
                                name={'not_register'}
                                checked={checkBox?.includes('not_register')}
                                onChange={e => {
                                    const { name } = e.target
                                    let arr = [...checkBox]
                                    if (arr.includes(name)) {
                                        if (arr.length > 1) {
                                            arr = arr.filter(item => item !== name)
                                        }
                                    } else {
                                        arr.push(name)
                                    }
                                    onCheckboxChange(arr)
                                }}
                                label={'Not Register'}
                            />
                        </div>
                    )}
                    <div className={subGridClass}>
                        {filter && (
                            <Select
                                id="length"
                                name="length"
                                value={selectedTab}
                                className="min-w-39"
                                options={filterOptions}
                                onChange={e => onTabChange?.(e.target.value)}
                            />
                        )}
                        {siteFilter && (
                            <Select
                                id="site"
                                name="site"
                                placeholder={'Select Site'}
                                value={components}
                                className="min-w-28"
                                options={siteOptions}
                                onChange={e => onComponentFilterChange?.(e.target.value)}
                            />
                        )}
                        {statusFilter && (
                            <Select
                                id="status"
                                name="status"
                                placeholder={'Select Status'}
                                value={companyType}
                                className="min-w-28"
                                options={[]}
                                onChange={e => onCompanyTypeChange?.(e.target.value)}
                            />
                        )}
                        {carrierFilter && (
                            <Select
                                id="warehouse"
                                name="warehouse"
                                placeholder={'Select Warehouse'}
                                value={warehouse}
                                className="min-w-28"
                                options={warehouseData}
                                onChange={e => onCompanyTypeChange?.(e.target.value)}
                            />
                        )}
                        {customerFilter && (
                            <Select
                                id="customer"
                                name="customer"
                                placeholder={'Select Customer'}
                                value={customer}
                                className="min-w-28"
                                options={customersData}
                                onChange={e => onCompanyTypeChange?.(e.target.value)}
                            />
                        )}
                        {asnTypeFilter && (
                            <Select
                                id="asn_type"
                                name="asn_type"
                                placeholder={'Asn Type'}
                                value={companyType}
                                className="min-w-28"
                                options={asnTypeOptions}
                                onChange={e => onCompanyTypeChange?.(e.target.value)}
                            />
                        )}
                        {orderTypeFilter && (
                            <Select
                                id="order_type"
                                name="order_type"
                                placeholder={'Order Type'}
                                value={orderType}
                                className="min-w-32"
                                options={orderTypeData}
                                onChange={e => onOrderTypeChange?.(e.target.value)}
                            />
                        )}
                        {buttons.length > 0 && (
                            <div className="flex flex-row items-center gap-3">
                                {buttons.map((text, index) => (
                                    <Button
                                        key={`button-${index}`}
                                        as="a"
                                        // href={url}
                                        data={{ download: text }}
                                        onClick={onClick}
                                        className="text-white border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                                    >
                                        {text === 'Add New' ? <AiOutlinePlus size={20} /> : null} {text}
                                    </Button>
                                ))}
                            </div>
                        )}
                        {(link || add_new) && (
                            <div className="flex flex-row items-center w-full gap-3 sm:w-auto">
                                {link && (
                                    <Button
                                        href={link}
                                        as="button"
                                        className="text-[#F05540] border-[#F05540] dark:text-[#F05540] dark:border-[#F05540]"
                                    >
                                        {link_name}
                                    </Button>
                                )}
                                {add_new && (
                                    <Link to={add_new}>
                                        <Button
                                            as="button"
                                            className="text-white border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                                        >
                                            <AiOutlinePlus size={20} /> {'Add New'}
                                        </Button>
                                    </Link>
                                )}
                            </div>
                        )}
                        {upload && (
                            <div className="flex flex-row items-center gap-3">
                                <Button
                                    onClick={onUpload}
                                    className="text-white border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                                >
                                    <HiOutlineUpload size={20} /> {'Upload'}
                                </Button>
                            </div>
                        )}
                        {download && (
                            <div className="flex flex-row items-center gap-3">
                                <Button
                                    onClick={onDownload}
                                    className="text-white border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                                >
                                    <HiOutlineDownload size={20} /> {'Export'}
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="bg-white mb-3 border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                <div className={`max-w-full overflow-x-auto ${className}`}>
                    <table className="w-full table-auto">
                        <thead>
                            <tr className={`bg-primary dark:bg-secondary bg-opacity-90 text-left`}>
                                {!visibleColumn
                                    ?.filter(item => !item?.hide)
                                    ?.find(({ header }) => header?.toLowerCase() === 'action') && (
                                    <th key="th-edit-column" className="px-3 py-2 font-medium text-white md:px-3 2xl:px-3">
                                        <div className="cursor-pointer px-2" onClick={() => setOpen(true)}>
                                            <HiOutlinePencilAlt size={20} />
                                        </div>
                                    </th>
                                )}
                                {select && (
                                    <th key="th-select-all" className="px-3 py-2 font-medium text-white md:px-3 2xl:px-3">
                                        <Checkbox
                                            id={'select_all'}
                                            name={'select_all'}
                                            checked={datas.length !== 0 && datas.length === ids.length}
                                            onChange={() => setIds(datas.length !== ids.length ? datas.map(row => row.id) : [])}
                                        />
                                    </th>
                                )}
                                {visibleColumn
                                    ?.filter(item => !item?.hide)
                                    ?.map((row, index) =>
                                        row?.header?.toLowerCase() === 'action' ? (
                                            <th
                                                key={`th-action-${index}`}
                                                className="px-3 py-2 font-medium text-white md:px-3 2xl:px-3"
                                            >
                                                <div className="cursor-pointer px-2" onClick={() => setOpen(true)}>
                                                    <HiOutlinePencilAlt size={20} />
                                                </div>
                                            </th>
                                        ) : (
                                            <th
                                                key={`th-${index}`}
                                                className={`font-medium text-white ${defoltclassName} ${row.className}`}
                                            >
                                                <div className="flex items-center justify-between gap-4">
                                                    {row.orderable ? (
                                                        <div
                                                            className="flex items-center justify-between gap-1 cursor-pointer"
                                                            onClick={() => {
                                                                if (sort[0].dir !== 'desc') {
                                                                    const data = [
                                                                        {
                                                                            column: row.field,
                                                                            dir:
                                                                                sort[0].column === row.field &&
                                                                                sort[0].dir === 'asc'
                                                                                    ? 'desc'
                                                                                    : 'asc',
                                                                        },
                                                                    ]
                                                                    onSort?.(data)
                                                                } else {
                                                                    onSort?.([{ column: '', dir: '' }])
                                                                }
                                                            }}
                                                        >
                                                            <p>{row.header}</p>
                                                            <div className="inline-flex flex-col space-y-[2px]">
                                                                {(sort[0].column !== row.field || sort[0].dir !== 'asc') && (
                                                                    <AiFillCaretUp size={14} style={{ margin: '-1px' }} />
                                                                )}
                                                                {(sort[0].column !== row.field || sort[0].dir !== 'desc') && (
                                                                    <AiFillCaretDown size={14} style={{ margin: '-1px' }} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        row.header
                                                    )}
                                                </div>
                                            </th>
                                        )
                                    )}
                            </tr>
                        </thead>
                        <tbody className="">
                            {datas.map((row, index) => (
                                <tr
                                    key={`tr-${index}`}
                                    className={`${(index + 1) % 2 === 0 && 'bg-whiten'} hover:bg-gray dark:hover:bg-boxdark2 ${view && 'cursor-pointer'}`}
                                    onClick={() => {
                                        if (view) {
                                            navigate(`${view}${row?.[viewId]}/view`)
                                            dispatch(setRecord(row))
                                        }
                                    }}
                                >
                                    {!visibleColumn
                                        ?.filter(item => !item?.hide)
                                        ?.find(({ header }) => header?.toLowerCase() === 'action') && (
                                        <td className="items-center px-3 py-2 text-sm text-black border-b border-stroke dark:border-strokedark dark:text-white md:px-3 2xl:px-3"></td>
                                    )}
                                    {select && (
                                        <td className="items-center px-3 py-2 text-sm text-black border-b border-stroke dark:border-strokedark dark:text-white md:px-3 2xl:px-3">
                                            <Checkbox
                                                id={'select_' + row.id}
                                                name={'select_' + row.id}
                                                checked={ids.includes(row.id)}
                                                onChange={() => {
                                                    var selectIds = [...ids]
                                                    if (!selectIds.includes(row.id)) {
                                                        selectIds.push(row.id)
                                                    } else {
                                                        selectIds = selectIds.filter(g => g !== row.id)
                                                    }
                                                    setIds(selectIds)
                                                }}
                                            />
                                        </td>
                                    )}
                                    {visibleColumn?.map((column, key) =>
                                        column.hide ? null : <ColumnTd key={`td-${key}`} row={row} column={column} />
                                    )}
                                </tr>
                            ))}
                            {datas.length === 0 && (
                                <tr>
                                    <td
                                        className={`border-b border-stroke dark:border-strokedark items-center text-center text-primary dark:text-white ${defoltclassName}`}
                                        colSpan="100%"
                                    >
                                        {loading ? 'Loading...' : 'Data not found'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                <div className={subGridClass}>
                    {totalPage > 1 || loading ? (
                        <div className="flex flex-col gap-3 p-3 sm:p-4 xl:p-6 sm:flex-row sm:items-center sm:justify-between">
                            <p className="text-sm text-black dark:text-white">
                                {`Showing ${from} to 
                        ${to} of ${total} entries`}
                            </p>
                            <nav>
                                <ul className="flex flex-wrap items-center w-full">
                                    {(loading ? loadingPages : pages)?.map((link, key) => (
                                        <li key={`li-${key}`}>
                                            {link !== pageIndex ? (
                                                <div
                                                    onClick={() => {
                                                        if (typeof link === 'string') {
                                                            if (link === 'Previous') {
                                                                if (pageIndex !== 1) {
                                                                    onPaginationChange(pageIndex - 1)
                                                                }
                                                            } else if (link === 'Next') {
                                                                if (pageIndex !== totalPage) {
                                                                    onPaginationChange(pageIndex + 1)
                                                                }
                                                            }
                                                        } else {
                                                            onPaginationChange(link)
                                                        }
                                                    }}
                                                    className={`flex items-center justify-center border py-[5px] px-4 font-medium text-sm  
                                                ${key !== 0 && link !== pageIndex && 'border-l-transparent'}
                                                ${
                                                    link === pageIndex
                                                        ? 'border-primary bg-gray text-primary dark:border-secondary dark:bg-graydark'
                                                        : 'text-black dark:text-white border-stroke hover:border-primary hover:bg-gray hover:text-primary dark:hover:text-secondary dark:border-strokedark dark:hover:border-secondary dark:hover:bg-graydark'
                                                }
                                                ${key === 0 && 'rounded-l-md'}
                                                ${pages.length === key + 1 && 'rounded-r-md'}
                                            `}
                                                >
                                                    {link}
                                                </div>
                                            ) : (
                                                <div
                                                    className={`flex items-center justify-center border py-[5px] px-4 font-medium text-sm 
                                                ${key !== 0 && link !== pageIndex && 'border-l-transparent'}
                                                ${key === 0 && 'border-r-transparent'}
                                                ${
                                                    link === pageIndex
                                                        ? 'border-primary bg-gray text-primary dark:border-secondary dark:bg-graydark'
                                                        : 'text-black dark:text-white border-stroke dark:border-strokedark'
                                                }
                                                ${key === 0 && 'rounded-l-md'}
                                                ${pages.length === key + 1 && 'rounded-r-md'}
                                            `}
                                                >
                                                    {link}
                                                </div>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </div>
                    ) : (
                        <div></div>
                    )}
                    {page_size_show && (
                        <div className="flex flex-row sm:items-center sm:justify-between gap-2 sm:py-2 xl:py-4 sm:px-4 xl:px-6">
                            <p className="text-black dark:text-white">{'Show'}</p>
                            <Select
                                id="length"
                                name="length"
                                value={pageSize ?? 10}
                                className="w-17"
                                options={lengthOption}
                                onChange={e => onSelectChange?.(e.target.value)}
                            />
                            <p className="text-black dark:text-white">{'Entries'}</p>
                        </div>
                    )}
                </div>
            </div>
            <Modal
                show={open}
                background="primary"
                maxWidth="6xl"
                onClose={() => {
                    setFilterColumn(visibleColumn)
                    setOpen(false)
                }}
            >
                <div className="flex flex-col gap-1 m-3 sm:flex-row sm:items-center sm:justify-between">
                    <h2 className="font-semibold text-white text-title-md dark:text-white">{'Edit Column'}</h2>
                </div>
                <div className="flex flex-col items-center">
                    <div className="w-full bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                        <div className="flex flex-col gap-3 p-6">
                            <div className="grid grid-cols-5 gap-x-4 gap-y-4">
                                {filterColumn.map((item, index) => (
                                    <Button
                                        key={`button-${index}`}
                                        className={`text-[#F05540] ${item.hide && 'opacity-25'} border-[#F05540] border dark:text-[#F05540] dark:border-[#F05540]`}
                                        onClick={() => {
                                            const newFilterColumn = filterColumn.map(col => {
                                                if (col.field === item.field) {
                                                    return { ...col, hide: !col.hide }
                                                }
                                                return col
                                            })
                                            setFilterColumn(newFilterColumn)
                                        }}
                                        type="button"
                                    >
                                        <div className="text-left rounded-md flex items-center gap-2 w-full">
                                            <span>{item.hide ? <HiOutlineEyeOff size={20} /> : <HiOutlineEye size={20} />}</span>
                                            <span>{item.header}</span>
                                        </div>
                                    </Button>
                                ))}
                            </div>
                            <div className="flex items-center justify-end gap-4 mt-3">
                                <Button
                                    type="button"
                                    className="flex items-center justify-center px-6 py-2 text-white transition border rounded-md cursor-pointer hover:bg-opacity-90 border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                                    onClick={() => {
                                        setVisibleColumn(filterColumn)
                                        dispatch(
                                            setTableColumn({
                                                key: localStorageKey,
                                                columns: filterColumn,
                                            })
                                        )
                                        setOpen(false)
                                    }}
                                >
                                    Save
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default Table
